import { Component, Injector, Input, OnInit } from "@angular/core";
import moment from "moment";
import { GenericComponent } from "../generic.component";
import { NotifyService } from "@core/services/notify.service";
import { DownloadDataApiExcelService } from "./services/download-data-api-excel.service";
import { DownloadOption } from "./types/download-option";

@Component({
    selector: "app-smartfleet-download-data-api-excel",
    templateUrl: "./download-data-api-excel.component.html",
    styleUrls: ["./download-data-api-excel.component.scss"],
    standalone: false
})
export class DownloadDataApiExcelComponent
  extends GenericComponent
  implements OnInit
{
  @Input() endpoint: string;
  @Input() options: DownloadOption[];
  @Input() fileName = "data";
  @Input() fileType = "xlsx";
  @Input() tooltip = "Download";
  @Input() positionTooltip = "right";

  constructor(
    injector: Injector,
    private notifyService: NotifyService,
    private service: DownloadDataApiExcelService
  ) {
    super(injector);
  }

  ngOnInit() {}

  downloadFile(option?: DownloadOption): void {
    if (option) {
      this.endpoint = option.endpoint;
      this.fileName = option.fileName;
    }

    this.service.getFileData(this.endpoint).subscribe(
      (data) => {
        if (data.headers.get("processed-by") === "Microservice") {
          this.notifyService.showInformationMessageWithTranslationKey(
            "mass-imports-messages.info-export-message-import"
          );
          return;
        }
      },
      async (error) => {
        const message = JSON.parse(await error.error.text()).message;
        this.notifyService.showErrorMessage(message);
      }
    );
  }
}
